import { createContext, useContext } from 'react';
import type React from 'react';
import type { User_EXT } from '../../Models/Classes';

export interface AuthContextType {
    sessionToken: string | null;
    setSessionToken: React.Dispatch<React.SetStateAction<string | null>>;
    sessionUser: User_EXT | null;
    setSessionUser: React.Dispatch<React.SetStateAction<User_EXT | null>>;
}

export const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const useAuth = (): AuthContextType => {
    const context = useContext(AuthContext);
    if (context === undefined) {
        throw new Error('useAuth must be used within an AuthProvider');
    }
    return context;
};
